import React, { useMemo } from "react";
import Popover from "../popover";
import PopoverMenuContent from "../popover-menu-content";
import PopoverMenuContentItem from "../popover-menu-content/popover-menu-content-item";

// Reusable sort dropdown. Pass the sort `options` ([{ id, label, withHr? }])
// from outside; the currently active `value` is highlighted.
const SortMenu = ({
    options = [],
    value,
    onChange,
    label = "Sort",
    iconSrc = "/images/icon/sort.svg",
    placement = "bottom",
    align = "end",
    className = "",
}) => {
    const items = useMemo(
        () =>
            options.map((option) => ({
                ...option,
                className: `${option.className || ""} ${option.id === value ? "sort-menu-item-selected" : ""}`.trim(),
                onClick: () => onChange && onChange(option.id),
            })),
        [options, value, onChange]
    );

    return (
        <Popover
            placement={placement}
            align={align}
            hideArrow
            className={`bimmatch-sort-menu ${className}`}
            content={<PopoverMenuContent items={items} />}
        >
            <PopoverMenuContentItem src={iconSrc} label={label} className="sort-menu-trigger" />
        </Popover>
    );
};

export default SortMenu;
